import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { bordColorTheme } from 'styles/styles.constants';
import './UploadWarning.scss';

const UploadWarning = () => {
  return (
    <article className="uploadWarning">
      <BordOneToneIcon
        variant="alertTriangleWarning"
        customWidth="16px"
        stroke={bordColorTheme.yellow[200]}
        standardSize={24}
        className="uploadWarningIcon"
      />
      <div className="uploadWarningContent">
        <p className="uploadWarningTitle">
          <strong>Subir la plantilla actualizada</strong>
        </p>
        <p className="uploadWarningDescription">Evita usar versiones antiguas, ya que pueden estar desactualizadas.</p>
      </div>
    </article>
  );
};

export default UploadWarning;
